import React, { useState, useEffect } from "react";
import { Container, makeStyles, Box } from "@material-ui/core";
import Page from "src/components/Page";
import Toolbar from "./Toolbar";
import PurchaseList from "./PurchaseList";
import { useSelector, useDispatch } from "react-redux";
import { fetchAllPurchaseInvoices } from "./_purchase_Action";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
}));

const PurchaseView = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [filterFn, setParentFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  useEffect(() => {
    dispatch(fetchAllPurchaseInvoices());
    // eslint-disable-next-line
  }, []);

  let allFetchData = useSelector((state) => state.purchase._allDetails) || [];
  let viewComponent = (
    <PurchaseList TableData={allFetchData} filterFn={filterFn} />
  );
  return (
    <Page className={classes.root} title="Stock">
      <Container maxWidth={false}>
        <Toolbar setParentFilterFn={setParentFilterFn} />

        <Box mt={3}>{viewComponent}</Box>
      </Container>
    </Page>
  );
};

export default PurchaseView;
